import React from "react";
import { useI18n } from "../i18n";
import { getTos, TOS_VERSION, TOS_EFFECTIVE } from "../data/tos";

export default function Terms() {
  const { lang } = useI18n();
  const pt = lang === "pt";
  const sections = getTos(lang);

  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 pt-28 pb-16" data-testid="page-terms">
      <div className="inline-flex items-center gap-2 rounded-full border border-gold-500/30 bg-gold-500/5 px-3 py-1 text-xs uppercase tracking-[0.2em] text-gold-400 font-mono">
        {pt ? "Termos de Uso" : "Terms of Service"}
      </div>
      <h1 className="mt-6 font-display text-4xl sm:text-5xl tracking-tight">
        {pt ? "Termos de Uso e Acordo de Assinatura" : "Terms of Service & Subscription Agreement"}
      </h1>
      <p className="mt-2 text-xs font-mono text-neutral-500 uppercase tracking-widest">
        {pt ? "Versão" : "Version"}: {TOS_VERSION} · {pt ? "Vigência" : "Effective"}: {TOS_EFFECTIVE}
      </p>

      <div className="mt-10 space-y-6">
        {sections.map((s, i) => (
          <div key={i} className="surface p-6" data-testid={`terms-sec-${i}`}>
            <h2 className="font-display text-xl tracking-tight">{s.h}</h2>
            <p className="mt-2 text-sm text-neutral-300 leading-relaxed whitespace-pre-line">{s.b}</p>
          </div>
        ))}
      </div>

      <p className="mt-10 text-xs text-neutral-500">
        {pt ? "Contato: " : "Contact: "}
        <a href="mailto:legal@goldora.global" className="text-gold-400 underline">legal@goldora.global</a>
        {" · "}
        <a href="mailto:support@goldora.global" className="text-gold-400 underline">support@goldora.global</a>
      </p>
    </div>
  );
}
